import { useDispatch } from 'react-redux';
import { Toggle } from '../../../ui/Toggle/Toggle';
import { SearchSection } from '../../SearchSection/SearchSection';
import { UsersTable } from '../UsersTable/UsersTable';
import { setOnlyShowInvitedUsers } from '../../../../store/slices/userManagementSlice';
import { useAppSelector } from '../../../../hooks/redux';
import { searchUsers } from '../../../../services/TeamService';
import { useCallback, useState, useRef } from 'react';
import { SearchUserDTO } from '../../../../types/Team.types';
import { EmptyState } from '../../../ui/EmptyState/EmptyState';
import SearchIcon from '../../../../assets/search_icon.svg';

export function UserOverview() {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState('');
  const currentQueryRef = useRef('');
  const onlyShowInvitedUsers = useAppSelector(
    (state) => state.userManagement.onlyShowInvitedUsers
  );
  const { account } = useAppSelector((state) => state.accountDefault);
  const [searchResults, setSearchResults] = useState<SearchUserDTO | null>(
    null
  );

  const handleSearchChange = useCallback(
    async (query: string) => {
      currentQueryRef.current = query;

      if (query.length === 0) {
        setSearchResults(null);
        return;
      }
      try {
        const response = await searchUsers(account!.id, query);

        if (currentQueryRef.current === query) {
          setSearchResults(response.data);
        }
      } catch (error) {
        console.error('Error searching users:', error);
        if (currentQueryRef.current === query) {
          setSearchResults(null);
        }
      }
    },
    [account]
  );

  return (
    <div className="flex flex-col w-full gap-4 justify-between flex-1 h-full">
      <SearchSection
        searchValue={searchValue}
        onSearchChange={(value) => {
          setSearchValue(value);
          handleSearchChange(value);
        }}
        placeholder="Search users by name"
      />
      <Toggle
        label="Only show invited users"
        checked={onlyShowInvitedUsers || false}
        onChange={() => {
          dispatch(setOnlyShowInvitedUsers(!onlyShowInvitedUsers));
        }}
        checkedBgColor="bg-purple-700"
      />

      {searchResults?.invitedUsers.count === 0 &&
      searchResults?.registeredUsers.count === 0 &&
      searchValue.length > 0 ? (
        <EmptyState
          icon={<img src={SearchIcon} alt="No data" className="w-9 h-9" />}
          title="No Users matched your criteria."
          description="Try adjusting your search."
        />
      ) : (
        <div className="flex-1 overflow-auto max-h-[calc(100vh-256px)]">
          <UsersTable searchResults={searchResults} />
        </div>
      )}
    </div>
  );
}
